import React from 'react'
import withIcon from '@/components/withIcon'

const IconMark = ({ className }) => {
  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6582 0.966759C11.8535 1.16202 11.8535 1.4786 11.6582 1.67387L4.65824 8.67387C4.56447 8.76763 4.4373 8.82031 4.30469 8.82031C4.17208 8.82031 4.0449 8.76763 3.95113 8.67387L0.451134 5.17387C0.255872 4.9786 0.255872 4.66202 0.451134 4.46676C0.646396 4.2715 0.962979 4.2715 1.15824 4.46676L4.30469 7.61321L10.9511 0.966759C11.1464 0.771497 11.463 0.771497 11.6582 0.966759Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default withIcon(IconMark)
